import { render, staticRenderFns } from "./source-blog.vue?vue&type=template&id=0ec5107c&scoped=true&"
import script from "./source-blog.vue?vue&type=script&lang=js&"
export * from "./source-blog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ec5107c",
  null
  
)

export default component.exports